import { Stack, Avatar, Typography, TextField, RadioGroup, Button, Radio } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import PagePicker from "src/components/page-picker/PagePicker";
import Uploader from "src/components/uploader/Uploader";
import { alert } from "src/services/alert";


const DiyHot = ({ data = {}, open, onClose, onChange }) => {

  const [form, setForm] = useState({
    leftTitle: data.leftTitle || '',
    leftSubtitle: data.leftSubtitle || '',
    leftImage: data.leftImage || '',
    leftPath: data.leftPath || '',

    topTitle: data.topTitle || '',
    topSubtitle: data.topSubtitle || '',
    topImage: data.topImage || '',
    topPath: data.topPath || '',

    bottomTitle: data.bottomTitle || '',
    bottomSubtitle: data.bottomSubtitle || '',
    bottomImage: data.bottomImage || '',
    bottomPath: data.bottomPath || '',
  });

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleSelectLink(pos) {
    PagePicker({
      onSelect(link) {
        // console.log(link);
        handleIptChange(`${pos}Path`, link);
      },
    });
  }

  function handleConfirm() {
    console.log(form);
    onChange(form);
  }

  return (
    <FormDialog title="热门模块" open={open} onClose={onClose} onConfirm={handleConfirm}>

      <FormItem title="左标题">
        <TextField fullWidth placeholder="请输入左标题" autoComplete="off" id="leftTitle" value={form.leftTitle} size="small" onChange={(e) => handleIptChange("leftTitle", e.target.value)} />
      </FormItem>
      <FormItem title="左副标题">
        <TextField fullWidth placeholder="请输入左副标题" autoComplete="off" id="leftSubtitle" value={form.leftSubtitle} size="small" onChange={(e) => handleIptChange("leftSubtitle", e.target.value)} />
      </FormItem>
      <FormItem title="左图" required>
        <Uploader images={form.leftImage} onUploaded={(v) => handleIptChange("leftImage", v)} />
      </FormItem>
      <FormItem title="跳转地址">
        <TextField fullWidth placeholder="跳转地址" disabled autoComplete="off" id="leftPath" value={form.leftPath} size="small" />
        <Button style={{ whiteSpace: "nowrap" }} onClick={() => handleSelectLink('left')}>
          选择地址
        </Button>
      </FormItem>

      <FormItem title="上标题">
        <TextField fullWidth placeholder="请输入上标题" autoComplete="off" id="topTitle" value={form.topTitle} size="small" onChange={(e) => handleIptChange("topTitle", e.target.value)} />
      </FormItem>
      <FormItem title="上副标题">
        <TextField fullWidth placeholder="请输入上副标题" autoComplete="off" id="topSubtitle" value={form.topSubtitle} size="small" onChange={(e) => handleIptChange("topSubtitle", e.target.value)} />
      </FormItem>
      <FormItem title="上图" required>
        <Uploader images={form.topImage} onUploaded={(v) => handleIptChange("topImage", v)} />
      </FormItem>
      <FormItem title="跳转地址">
        <TextField fullWidth placeholder="跳转地址" disabled autoComplete="off" id="topPath" value={form.topPath} size="small" />
        <Button style={{ whiteSpace: "nowrap" }} onClick={() => handleSelectLink('top')}>
          选择地址
        </Button>
      </FormItem>


      <FormItem title="下标题">
        <TextField fullWidth placeholder="请输入下标题" autoComplete="off" id="bottomTitle" value={form.bottomTitle} size="small" onChange={(e) => handleIptChange("bottomTitle", e.target.value)} />
      </FormItem>
      <FormItem title="下副标题">
        <TextField fullWidth placeholder="请输入下副标题" autoComplete="off" id="bottomSubtitle" value={form.bottomSubtitle} size="small" onChange={(e) => handleIptChange("bottomSubtitle", e.target.value)} />
      </FormItem>
      <FormItem title="下图" required>
        <Uploader images={form.bottomImage} onUploaded={(v) => handleIptChange("bottomImage", v)} />
      </FormItem>
      <FormItem title="跳转地址">
        <TextField fullWidth placeholder="跳转地址" disabled autoComplete="off" id="bottomPath" value={form.bottomPath} size="small" />
        <Button style={{ whiteSpace: "nowrap" }} onClick={() => handleSelectLink('bottom')}>
          选择地址
        </Button>
      </FormItem>


    </FormDialog>
  );
};

export default DiyHot;
